// extracted by mini-css-extract-plugin
export default {"NotesContainer":"_NotesContainer--fAdux","NotesListHeader":"_NotesListHeader--HUlw5","NotesList":"_NotesList--NnPU5","AddNoteButton":"_AddNoteButton--eIiae"};